export const API_URL = "https://norma.nomoreparties.space/api/";

export const WS_API_URL = "wss://norma.nomoreparties.space";

export const INGREDIENTS = "ingredients";

export const ORDERS = "orders";

export const MODAL_ROOT = document.getElementById("modal-root");

export const REGISTRATION_USER = "auth/register";

export const LOGIN_USER = "auth/login";

export const PASSWORD_RESET = "password-reset";

export const SET_NEW_PASSWORD = "password-reset/reset";

export const TOKEN_REFRESH= "auth/token";

export const AUTH_USER = "auth/user";

export const LOGOUT_USER = "auth/logout";

